import {
  DynamicOption,
  DynamicOptionObjectTypes,
} from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateScreenComponentEditor/types';
import { getDisplayNameForStep } from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateScreenEditor/utils';
import { InquiryTemplateVersionStep } from 'dashboard/models/inquiry-template-version';
import { FieldSchema } from 'lib/fields';
import { assertNever } from 'lib/utils/types';

export const filterDynamicOptions = (
  dynamicOption: DynamicOption,
  steps: InquiryTemplateVersionStep[],
  fieldSchema: FieldSchema[],
) => {
  let dynamicOptions = [];
  switch (dynamicOption['object-type']) {
    case DynamicOptionObjectTypes.Step:
      dynamicOptions = steps
        .filter((step) => dynamicOption['step-types'].includes(step.type))
        .map((step) => ({
          value: step.name,
          label: getDisplayNameForStep(step),
        }));
      break;
    case DynamicOptionObjectTypes.Field:
      dynamicOptions = fieldSchema
        .filter((field) => field.type === dynamicOption['field-type'])
        .map(({ key, label }) => ({ label: label, value: key }));
      break;
    default:
      assertNever(dynamicOption['object-type']);
  }
  return dynamicOptions;
};
